import React from 'react';
import './SectionHeader.css';

const SectionHeader = ({ title, description }) => (
  <div className="section-header">
    <div className="section-header__title">{title}</div>
    {description && (
      <div className="section-header__desc">{description}</div>
    )}
  </div>
);

export default SectionHeader;
